import React, { useEffect, useState } from "react";
import SubscriptionBox from "../../components/Subscription/SubscriptionBox";
import ExpandLeft from "../../assets/icons/ExpandWhiteLeft";
import HeroImage from "../../assets/icons/svgicons/SubscriptionHeroImage.svg";
import { subscriptions, useSubscriptionStore, useUserStore } from "../../state";
import { createSubscriptionPaymentLink } from "../../backend-services/subscription";
import { Link } from "react-router-dom";
import sales from "../../components/Images/Ellipse1437.webp";
import { useTranslation } from "react-i18next";
import { CloseIcon } from "../../assets/icons";

interface SubscriptionPageProps {
  close: () => void; // Function to close the modal
}

const SubscriptionPage: React.FC<SubscriptionPageProps> = ({ close }) => {
  const { t } = useTranslation("subscription");
  const [price, setPrice] = useState<number>(0);
  const [email, setEmail] = useState<string>("");
  const [companyId, setCompanyId] = useState<string>("");
  const [subscriptionId, setSubscriptionId] = useState<number>(0);
  const [plan, setPlan] = useState<string>("");
  const [isChoosing, setIsChoosing] = useState<boolean>(false);
  const [indexState, setIndexState] = useState<number | null>(null);
  const { subscriptionData } = useSubscriptionStore();
  const { user } = useUserStore((state) => ({ user: state.user }));

  const { subscriptionList, fetchListSubscription, isLoading } =
    useSubscriptionStore((state) => ({
      subscriptionList: state.subscriptionList,
      subscription: state.subscription,
      fetchListSubscription: state.fetchListSubscription,
      isLoading: state.isLoading,
    }));

  useEffect(() => {
    fetchListSubscription();
    setEmail(user.email!);
    setCompanyId(user.id!);
  }, [fetchListSubscription, user]);

  const callbackUrl = `${window.location.origin}/settings?tab=subscription&status=processing`;


  const handlePaymentSucess = async (plan: string) => {
    try {
      const data = await createSubscriptionPaymentLink({
        paymentProvider: "paystack",
        plan: plan,
        callback_url: callbackUrl,
      });
      const { authorization_url } = data;
      window.location = authorization_url;
    } catch (error: any) {
      throw new Error(error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 backdrop-blur-sm ">
      <div className="bg-white md:rounded-[20px] w-full max-w-5xl scroll-container md:max-h-[90vh] 2xl:max-h-auto  max-h-screen pb-10">
      <div className="relative bg-[#E0EEFE] overflow-hidden text-center">

      <button className="absolute right-10 top-[50px] hidden md:flex" onClick={close}>
      <CloseIcon height="40" width="40"   />
      </button>

      <button className="absolute right-10 top-[50px]  md:hidden flex" onClick={close}>
      <CloseIcon height="30" width="30"   />
      </button>
          {/* <div className="flex flex-row pl-[20px] md:pl-[115px] pt-[64px] text-[#fff]">
            <span className="">
              <ExpandLeft />
            </span>
            <button onClick={close} className="ml-2">
              <span className="">Go Back</span>
            </button>
          </div> */}


          <div className=" text-center flex flex-col justify-center items-center md:mt-[58px] mt-[50px]">
          <h1 className="md:text-[48px] text-[20px] font-bold text-[#0D3C6D] font-recoleta">Our Pricing</h1>
          <p className="md:text-lg mt-2 w-[376px]">
            Unlock Esemié’s exclusive features and give your business the prime boost it deserves.
          </p>
          </div>


          <div className="lg:mt-[52px] w-full  mt-20">
            <SubscriptionBox
              show={handlePaymentSucess}
              isChoosing={isChoosing}
              indexState={indexState}
            />
          </div>

          {/* <div className="px-[5.6%] px- md:py-[57.5px] bg-white flex justify-between items-center mt-[99px] shadow">
            <div className=" flex items-center gap-3 md:gap-6">
              <img
                src={sales}
                alt="sales"
                className="w-[80px] h-[80px] rounded-full"
              />
              <p className=" text-[14px] md:text-[18px] lg:text-[24px] font-semibold lg:leading-[28.8px]">
                Want an{" "}
                <span className="text-[#044E97] font-bold">Unlimited plan</span>{" "}
                that allows you to do more?
              </p>
            </div>
            <a
              href="mailto:sales@esemie.io"
              className="w-[150px] md:w-[193px] h-12 md:h-16 rounded-[8px] flex justify-center items-center text-center bg-[#FF6702] text-white text-[14px] md:text-[18px] font-bold"
            >
              Contact Sales
            </a>
          </div> */}

          <div className="bg-white absolute h-[80vh] bottom-0 w-full pb-10 hidden md:flex">

          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPage;